import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useEffect } from 'react';
import { useController, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PriceInputWithEarnings from '../../../../../../DollarPriceInput/variants/PriceInputWithEarnings';
import useValidation from '../../useValidation';
import yupResolver from '../../../../../../utils/yupResolver';
export const PLACEHOLDER_FOLDER_PRICE = 10;
const PriceField = ({ name = 'price', onChange, currentGallection })=>{
    var _currentGallection_premiumFolderData, _errors_name;
    const { t } = useTranslation();
    const validationSchema = useValidation();
    var _currentGallection_premiumFolderData_dollarPrice;
    const formContext = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        resolver: yupResolver(validationSchema),
        defaultValues: {
            price: (_currentGallection_premiumFolderData_dollarPrice = currentGallection === null || currentGallection === void 0 ? void 0 : (_currentGallection_premiumFolderData = currentGallection.premiumFolderData) === null || _currentGallection_premiumFolderData === void 0 ? void 0 : _currentGallection_premiumFolderData.dollarPrice) !== null && _currentGallection_premiumFolderData_dollarPrice !== void 0 ? _currentGallection_premiumFolderData_dollarPrice : PLACEHOLDER_FOLDER_PRICE
        }
    });
    // Data is submitted on change which makes this a bit ugly
    const { handleSubmit, watch, register, control, errors } = formContext;
    register('price');
    // monitor price value and update Gallection
    const watchPrice = watch('price');
    useEffect(()=>{
        handleSubmit((data)=>{
            if (data.price) {
                onChange(data.price.toString());
            }
        })();
    }, [
        handleSubmit,
        onChange,
        watchPrice
    ]);
    const errorMessage = (_errors_name = errors[name]) === null || _errors_name === void 0 ? void 0 : _errors_name.message;
    const _useController = useController({
        name,
        control
    }), { field: { ref } } = _useController, fieldProps = _object_without_properties(_useController.field, [
        "ref"
    ]);
    return /*#__PURE__*/ React.createElement(PriceInputWithEarnings, _object_spread_props(_object_spread({}, fieldProps), {
        label: t('mediapopup.gallections.a11y.priceInputLabel'),
        error: errorMessage,
        placeholder: PLACEHOLDER_FOLDER_PRICE,
        ref: ref,
        productType: "gallery"
    }));
};
PriceField.displayName = 'PriceField';
export default PriceField;

//# sourceMappingURL=PriceField.js.map